import UsersImagesSection from "./sections/usersImagesSection";
export default function usersSliders() {
    const sections = document.querySelectorAll('[data-users-images]')
    sections.forEach(section => new UsersImagesSection(section));
}